import axios from 'axios'
import variable from '@/util/variable'
import help from '@/util/help'
import main from '../main'

let myAxios = axios.create({
    baseURL: '/',
    responseType: 'json',
    withCredentials: true,
    headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': "application/json;charset=UTF-8",
    },
})


myAxios.interceptors.request.use(function (config) {
    config.headers['Authorization'] = help.tokenHelp.get();
    return config;
}, function (error) {
    return Promise.reject(error);
})

function doError(res, reject, isBubbling) {
    if (res && res.data) {
        if (variable.tokenInvalid.includes(res.data.status)) {
            help.error(res.data.msg)
            help.tokenHelp.remove()
            main.$store.commit('setPage', variable.pageType.LOGIN)
        } else {
            !isBubbling && help.error(res.data.msg);
        }
    } else {
        !isBubbling && help.error(res ? res.message : '服务器内部错误')
    }

    reject(res.data)
}

function requestFunc(func, url, params, headers = {}, isBubbling = false) {
    return new Promise((resolve, reject) => {
        let param1 = {},
            param2 = {};
        if (['get', 'delete'].includes(func)) {
            param1 = {params, headers};
        } else {
            param1 = params;
            param2 = {headers}
        }
        myAxios[func](url, param1, param2)
            .then(res => {
                if (res.data.status === variable.successCode) {
                    if (typeof res.data.data === 'object') {
                        res.data.data.rootData = res;
                        resolve(res.data.data)
                    } else {
                        resolve(res.data)
                    }
                } else {
                    doError(res, reject, isBubbling)
                }
            })
            .catch(res => {
                doError(res, reject, isBubbling)
            })
    })
}

export default {
    service: myAxios,
    axios,
    get(url, params, headers) {
        return requestFunc('get', url, params, headers)
    },
    post(url, params = {}, headers = {}) {
        return requestFunc('post', url, params, headers)
    },
    put(url, params = {}, headers = {}) {
        return requestFunc('put', url, params, headers)
    },
    patch(url, params = {}, headers = {}) {
        return requestFunc('patch', url, params, headers)
    },
    delete(url, params = {}, headers = {}) {
        return requestFunc('delete', url, params, headers)
    },
    mounted() {
        setTimeout(() => {
            if (this.$refs.add) {
                this.ue.config.initialFrameWidth = this.$refs.add.$el.clientWidth
                this.ue.finished = true
            }
        }, 300)
    },
}
